import { useQuery } from '@tanstack/react-query';
import { m6_2Endpoints } from '../../../endpoints/m6-2';
import { ICoachTeam } from '../../../models/m6-2';

/**
 * Lista team dove il coach corrente è coach/director (M6.2 GET /teams/me).
 * Usato da wizard Step 3 (dropdown altro team) e sidebar.
 */
export function useMyTeams() {
  return useQuery<ICoachTeam[]>({
    queryKey: ['m6-2', 'my-teams'],
    queryFn: async () => {
      const res = await m6_2Endpoints.getMyTeams();
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
